import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { IntakeFlow } from "./pages/IntakeFlow";
import { Pricing } from "./pages/Pricing";
import { CheckoutSuccess } from "./pages/CheckoutSuccess";
import { CheckoutCancel } from "./pages/CheckoutCancel";
import { MemberDashboard } from "./pages/MemberDashboard";
import { RouteGate } from "./components/RouteGate";
import { SettingsPage } from "./pages/Settings";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import { AuthCallback } from "./pages/AuthCallback";
import { NavDebug } from "./components/NavDebug";

function App() {
  const basename = import.meta.env.VITE_ROUTER_BASENAME || "";
  const appEnabled = String(import.meta.env.VITE_APP_ENABLED).toLowerCase() === "true";

  return (
    <BrowserRouter basename={basename}>
      <NavDebug />
      <Routes>
        {/* Canonical: /intake */}
        <Route path="/" element={<Navigate to="/intake" replace />} />
        <Route
          path="/intake"
          element={
            <RouteGate mode="intake">
              <IntakeFlow />
            </RouteGate>
          }
        />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/checkout/success" element={<CheckoutSuccess />} />
        <Route path="/checkout/cancel" element={<CheckoutCancel />} />

        {/* App routes: disabled in prod until launch */}
        <Route
          path="/dashboard"
          element={
            appEnabled ? (
              <RouteGate mode="dashboard">
                <MemberDashboard />
              </RouteGate>
            ) : (
              <Navigate to="/intake" replace />
            )
          }
        />
        <Route
          path="/settings"
          element={
            appEnabled ? (
              <RouteGate mode="dashboard">
                <SettingsPage />
              </RouteGate>
            ) : (
              <Navigate to="/intake" replace />
            )
          }
        />
        <Route path="/auth/callback" element={<AuthCallback />} />

        <Route path="*" element={<Navigate to="/intake" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export { App };
